"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SVG = function SVG(_ref) {
  var fill = _ref.fill;
  return _react.default.createElement("svg", {
    width: "40px",
    position: "absolute",
    height: "30px",
    "z-index": "0",
    viewBox: "0 0 28 21",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, "round-format_quote-24px"), _react.default.createElement("desc", null, "Created with Sketch."), _react.default.createElement("g", {
    id: "Testimonials",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Design-kit",
    transform: "translate(-1065.000000, -6773.000000)"
  }, _react.default.createElement("g", {
    id: "Group-32",
    transform: "translate(165.000000, 6392.000000)"
  }, _react.default.createElement("g", {
    id: "Group-27",
    transform: "translate(135.000000, 125.000000)"
  }, _react.default.createElement("g", {
    id: "Group-26"
  }, _react.default.createElement("g", {
    id: "Group-49"
  }, _react.default.createElement("g", {
    id: "round-format_quote-24px",
    transform: "translate(780.000000, 266.000000) scale(-1, 1) rotate(-180.000000) translate(-780.000000, -266.000000) translate(760.000000, 241.000000)"
  }, _react.default.createElement("polygon", {
    id: "Path",
    points: "0.0110831343 0.295834743 39.0354734 0.295834743 39.0354734 49.3154426 0.0110831343 49.3154426"
  }), _react.default.createElement("path", {
    d: "M11.075205,34.61819 C11.9148392,34.61819 12.6886197,34.0211312 13.0508148,33.0946606 L15.3886197,27.2476018 C15.6191075,26.6711312 15.7343514,26.0534841 15.7343514,25.4152488 L15.7343514,16.0887782 C15.7343514,14.9564253 14.9934977,14.0299547 14.0880099,14.0299547 L7.50264406,14.0299547 C6.59715626,14.0299547 5.8563026,14.9564253 5.8563026,16.0887782 L5.8563026,24.3240723 C5.8563026,25.4564253 6.59715626,26.3828959 7.50264406,26.3828959 L10.795327,26.3828959 L9.09959528,30.6240723 C8.35874162,32.4564253 9.42886357,34.61819 11.075205,34.61819 Z M27.5386197,34.61819 C28.3782538,34.61819 29.1520343,34.0211312 29.5142294,33.0946606 L31.8520343,27.2476018 C32.0825221,26.6711312 32.197766,26.0534841 32.197766,25.4152488 L32.197766,16.0887782 C32.197766,14.9564253 31.4569124,14.0299547 30.5514245,14.0299547 L23.9660587,14.0299547 C23.0605709,14.0299547 22.3197172,14.9564253 22.3197172,16.0887782 L22.3197172,24.3240723 C22.3197172,25.4564253 23.0605709,26.3828959 23.9660587,26.3828959 L27.2587416,26.3828959 L25.5630099,30.6240723 C24.8221563,32.4564253 25.8922782,34.61819 27.5386197,34.61819 Z",
    id: "Shape",
    fillOpacity: "0.5",
    fill: fill,
    fillRule: "nonzero"
  })))))))));
};

var _default = SVG;
exports.default = _default;